import { first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { BriefingService } from "../services";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as _ from 'lodash';

@Component({
    styles: [`
        .big-icon {
            font-size: 20px
        }
    `],
    template: `
        <div fxLayout="column">
            <mat-toolbar color="primary" id="picker-menu">
                <button  mat-button class="menu-button" (click)="goBack()"><i class="big-icon fa fa-arrow-left"></i></button>
                <h2>Share Briefing</h2>
                <span fxFlex></span>
                <button mat-button [routerLink]="['/settings']" matTooltip="Settings" matTooltipPosition="below"><mat-icon>settings</mat-icon></button>
            </mat-toolbar>
            <div fxLayout="row">
                <div [formGroup]="form" fxFlex="50" fxLayout="column" fxFlexOffset="25">
                    <h2>Share Briefing: "{{briefing?.briefingTitle}}" with others</h2>
                    <div fxLayout="row">
                        <mat-form-field fxFlex="100">
                            <label>Email Addresses</label>
                            <mat-chip-list #chipList>
                                <mat-chip *ngFor="let email of emailAddresses" (removed)="removeEmailAddress(email)">
                                    {{email}}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                                <input fxFlex
                                       matInput
                                       [matChipInputFor]="chipList"
                                       [matChipInputAddOnBlur]="true"
                                       (matChipInputTokenEnd)="addEmailAddress($event)">
                            </mat-chip-list>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row">
                        <mat-form-field fxFlex="100">
                            <label>Message</label>
                            <input matInput formControlName="message">
                            <mat-error *ngIf="form.get('message').hasError('required')">An invitation message is required</mat-error>
                        </mat-form-field>
                    </div>
                    <button mat-raised-button color="primary" [disabled]="noTouching || !emailAddresses.length" (click)="sendInvitation()">
                        Send
                    </button>
                </div>
            </div>
        </div>
    `
})
export class BriefingShareComponent implements OnInit, OnDestroy {
    briefing: any;
    paramSubscription: Subscription;
    form: FormGroup;
    emailAddresses = [];
    noTouching: boolean;
    
    constructor(private route: ActivatedRoute,
                private router: Router,
                private snackbar: MatSnackBar,
                private location: Location,
                fb: FormBuilder,
                private briefingService: BriefingService) {
        this.form = fb.group({
            emailAddresses: [], 
            message: [''] 
        });
    }

    ngOnInit(): void {
        this.paramSubscription = this.route.params
        .subscribe((params: Params) => {
            this.briefingService.getBriefing(params.briefingId).pipe(first())
            .subscribe(briefing => this.briefing = briefing);
        });
    }
    
    addEmailAddress($event) {
        const reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

        if (!_.isEmpty($event.value)) {
            if (reg.test($event.value.toLowerCase())) {
                $event.input.value = '';
                this.emailAddresses.push($event.value);
            } else {
                this.snackbar.open(`${$event.value} is not a valid email address and so cannot be added`, 
                               'OK', 
                               { duration: 5000 });
            }
            
        }
    }

    removeEmailAddress(email) {
        this.emailAddresses.splice(this.emailAddresses.indexOf(email), 1);
    }

    sendInvitation() {
        this.noTouching = true;
        this.briefingService.inviteToBriefing(this.briefing.id, { 
            message: this.form.get('message').value,
            briefingTitle: this.briefing.briefingTitle,
            emails: _.map(this.emailAddresses, email => email.toLowerCase())
        }).pipe(first())
        .subscribe(() => {
            this.router.navigate(['briefings']);
            this.snackbar.open(`${this.emailAddresses.length === 1 ? 'Invitation' : 'Invitations'}  sent to ${this.emailAddresses.join(', ')}`, 
                               'OK', 
                               { duration: 10000 });
        },
        () => {
            this.noTouching = false;
            this.snackbar.open('Errors occurred, please try again or contact your site administrator.', 'OK', { duration: 10000, panelClass: ['errorSnackbar']});
        });
    }

    goBack = () => this.location.back();

    ngOnDestroy(): void {
        this.paramSubscription.unsubscribe();
    }
}